import React from 'react';
import Button from "../../../../bootstrap/components/button/Button";
import {useHistory} from 'react-router-dom';
import routes from "../../../routing/routes";
import __ from "../../../i18n";

export function CompleteEnrollmentButton({course}) {
    const history = useHistory();

    return (
        <Button
            title={__('Complete enrollment')}
            appearance="solid-primary"
            size="large"
            onClick={() => {
                history.push(routes.checkout.getUrl('course', course.id));
            }}
        />
    );
}
